import styled from '@emotion/styled';
import { theme } from '../../theme';
export const StyledAutocompleteWrapper = styled.div `
	/* needed to position results correctly */
	position: relative;
`;
export const StyledResultsList = styled.div `
	background: white;
	margin-bottom: 1rem;

	/*
	it's important that box-sizing is content-box, otherwise setting the height
	does not account for the border
	*/
	box-sizing: content-box;

	border-radius: ${theme.radii.radii30};
	border: 1px solid rgba(230, 234, 242, 1);
	box-shadow: 0px 4px 10px 0px rgba(10, 24, 43, 0.08);

	/* put the y-scroll on the wrapped results container */
	overflow-y: hidden;
	& > * {
		height: 100%;
		overflow-y: scroll;
	}
`;
export const StyledErrorResultsList = styled(StyledResultsList) `
	color: ${theme.colors.NE100};
`;
//# sourceMappingURL=Autocomplete.styled.js.map